import { useAuth, UserType } from 'context/authentication/useAuth'
import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useFeatureFlagService } from './useFeatureFlagService'

interface ProtectedRouteProps {
  children: ReactNode
  minimumRole?: UserType
}

export default function ProtectedRoute({
  children,
  minimumRole = 'Standard',
}: ProtectedRouteProps) {
  const { isAuthenticated, isAllowed } = useAuth()
  const { enableUserTypes } = useFeatureFlagService()

  if (!isAuthenticated) {
    return <Navigate to="/login" />
  }

  if (enableUserTypes && !isAllowed(minimumRole)) {
    return <Navigate to="/not-authorized" replace />
  }

  return children
}
